import { render, staticRenderFns } from "./panel_jihua.vue?vue&type=template&id=0a02b968&scoped=true&"
import script from "./panel_jihua.vue?vue&type=script&lang=js&"
export * from "./panel_jihua.vue?vue&type=script&lang=js&"
import style0 from "./panel_jihua.vue?vue&type=style&index=0&id=0a02b968&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a02b968",
  null
  
)

export default component.exports